<template>
	<div>
		<!-- <v-btn
			color="primary"
			@click="dialogDecrease = true"
		>
			Merma
		</v-btn> -->
		
		<!-- <v-dialog
			width="700px"
			persistent
			v-model="dialogDecrease"
		>
			<decrease 	@closeDialogDecrease="closeDialogDecrease"
			@saveDecrease="saveDecrease"
			v-model="decrease"
			></decrease>
			
		</v-dialog> -->
		<frz-reception-fresh :title="title" :ship="ship">
		</frz-reception-fresh>
	</div>
</template>

<script>
	import Decrease from '@/components/FrozenProduction/Reception/decrease.vue';
	import FrzReceptionFresh from './FrzReceptionFresh.vue';
	
	export default {
		components: {
			FrzReceptionFresh,
			Decrease
		},

		data() {
		
			return {
				title: "Recepción Congelado - Campo",
				dialogDecrease: false,
				decrease: {},
				ship: 2
			}
		},
		
		methods: {
			closeDialogDecrease() {
				this.dialogDecrease = false;
			},

			saveDecrease(item)
			{
				this.decrease = item;
			}
		}
	}
</script>